module.exports = {"component":"color-picker","status":"prod","display-name":"Color Pickers","SLDS-component-path":"/components/color-picker","url-slug":"color-picker"}


//////////////////
// WEBPACK FOOTER
// ./components/color-picker/docs.json
// module id = 186
// module chunks = 0